export const splitToCols = (items: any) => {
	const left: any[] = [];
	const right: any[] = [];
	items.forEach((it: any, i: any) => (i % 2 === 0 ? left : right).push(it));
	return [left, right];
};

export const interleave = (left: any, right: any) => {
	const out = [];
	const max = Math.max(left.length, right.length);
	for (let i = 0; i < max; i++) {
		if (i < left.length) out.push(left[i]);
		if (i < right.length) out.push(right[i]);
	}
	return out;
};

export const sortMarketsByPriorityStable = (items: any) =>
	[...items].sort((a: any, b: any) => {
		const pa = a.priority ?? null;
		const pb = b.priority ?? null;
		if (pa != null && pb != null) return pa - pb;
		if (pa != null) return -1;
		if (pb != null) return 1;
		return new Date(a.created_date).getTime() - new Date(b.created_date).getTime();
	});
